<div class="spinner">
  <div class="spinner-ring"></div>
  <div class="spinner-ring"></div>
  <div class="spinner-ring"></div>
</div>
<div class="spinner-text" [translate]="text"></div>